'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import OpencartServices from '@/components/technologies/opencart-services';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Empower Your E-Commerce & M-Commerce Business with Top-Rated OpenCart Development Services!"
                alt="hero image"
                title="hero image"
                width={588}
                height={550}
                path={'opencart-developer-hero'}
                bgPath={'hero-bg-grunge'}
            >
                OpenCart <div>Development Company</div>
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="OpenCart" />
            <ContetVideoSection title="Customized OpenCart Solutions for Your Various Online Business Needs">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Right from minor customizations to building full-fledged e-commerce stores, we provide a full-suit
                        OpenCart development solution to startups, businesses and large enterprise. We house the best team of
                        skillful and advanced e-commerce web developers and OpenCart specialists that assist us to build advanced,
                        robust and secure online stores that look stunning and unique.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        At Moweb, we put our highest emphasis on end-customer experience and developing assets that deliver best
                        user interaction. We are established since 2008 and crowned as the leading OpenCart development company.
                    </p>
                </>
            </ContetVideoSection>
            <OpencartServices></OpencartServices>
            <HireProcess
                bg="bg-opencart"
                pageTitle="Want to Know More About Our OpenCart Solutions?"
                desc="OpenCart solutions include development, customization, integration, migration, optimization, and maintenance for your online store."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For OpenCart Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best OpenCart Developers"
                desc="Looking to hire a skilled and experienced OpenCart developer to join our team. As an OpenCart developer, you will be responsible for the development, customization, and maintenance of our OpenCart-based online store. Your expertise will contribute to creating a seamless and user-friendly shopping experience for our customers."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
